// extracted by mini-css-extract-plugin
export default {"header":"Template_header__EQzMo","main":"Template_main__G1eII","footer":"Template_footer__HQYFb"};